import React from "react";
import DraftArticles from "./DraftArticles";

export default function DraftArticlesPage() {
  return (
    <React.Suspense fallback="Loading articles...">
      <DraftArticles />
    </React.Suspense>
  );
}
